import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TimeZoneInterceptor implements HttpInterceptor {
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const timeZone = this.getOffSet();
        const modifiedReq = req.clone({ 
        headers: req.headers.set('ClientTimeZone', timeZone),
        });
        return next.handle(modifiedReq);
    }

    getOffSet() {
        let offset = new Date().getTimezoneOffset();
        let result = 0 - offset;
        let timeZone = this.toHoursAndMinutes(result);                           
        let final = (result >= 0 ? "+" : "") + timeZone.hours + ":" + timeZone.minutes.toString();
        return final.toString();
    }

    toHoursAndMinutes(totalMinutes : number) {
        const hours = this.padLeft( Math.floor(totalMinutes / 60).toString(), "0", 2);
        const minutes = this.padLeft( Math.floor(totalMinutes % 60).toString(), "0", 2);
      
        return { hours, minutes };
    }

    padLeft(text: string, padChar: string, size: number): string {
        return (String(padChar).repeat(size) + text).substr(size * -1, size);
    }
}